import request from '@/utils/request'

export function confirmSiteRequestDrug(data) {
  const method = 'put'
  const url = '/siterequest_has_drug'
  return request({
    url,
    method,
    data
  })  
}

// richiesta dai centri
export function requestSiteRequest (siterequest) {
  const method = 'put'
  const url = `/siterequest/request/${siterequest.id}`
  return request({
    url,
    method,
    data: { note: siterequest.note }
  })
}

// EMN conferma la richiesta dei centri
export function confirmSiteRequest (siterequest) {
  const method = 'put'
  const url = `/siterequest/confirm/${siterequest.id}`
  return request({
    url,
    method,
    data: { note: siterequest.note }
  })
}

export function cancelSiteRequest (siterequest) {
  const method = 'put'
  const url = `/siterequest/cancel/${siterequest.id}`
  return request({
    url,
    method,
    data: { note: siterequest.note }
  })
}

export function drugAvailability (protocolId, country, search) {
  const method = 'get'
  const url = `/siterequest/drug_availability/${protocolId}/${country}/${encodeURIComponent(search)}`
  return request({
    url,
    method
  })
}

export function drugIdAvailability (drugId) {
  const method = 'get'
  const url = `/siterequest/drugid_availability/${drugId}`
  return request({
    url,
    method
  })
}

// il deposito spedisce i farmaci
export function storageConfirm (siterequest) {
  const method = 'put'
  const url = `/siterequest/sent/${siterequest.id}`
  const data = { response_eta: siterequest.response_eta, note: siterequest.note }
  return request({
    url, method, data
  })
}

// il centro riceve i farmaci
export function siterequestReceived (siterequest_id) {
  const method = 'put'
  const url = `/siterequest/received/${siterequest_id}`
  return request({
    url, method
  })
}

// la lista delle siterequest e' una custom API perche'
// mi serve anche la lista delle drugs
export function getSiterequestList (entity, filters, pagination) {
  const method = 'get'
  const url = '/siterequest/list'

  // custom multifilter
  if (filters['siteresponse_has_drug.drug_id']) {
    const drug_id = filters['siteresponse_has_drug.drug_id']
    filters['drug_id'] = [ {'siteresponse_has_drug.drug_id': drug_id}, {'siterequest_has_drug.drug_id': drug_id }]
    delete filters['siteresponse_has_drug.drug_id']
  }

  return request({
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    },
    url, method
  })
}


export function regenerateSiterequestPdf (siterequest) {
  const method = 'post'
  const url = `/siterequest/regeneratepdf/${siterequest.id}`
  return request({ url, method })
}